// extracted by mini-css-extract-plugin
module.exports = {"errorText":"Table_errorText__3XDmg","canDrag":"Table_canDrag__uk3GT","dragging":"Table_dragging__15n7h","canClick":"Table_canClick__gczrk"};